import { IBasePickerSuggestionsProps, ITag, PivotItem } from '@fluentui/react';

//store 
import * as MedicalProtocolsStore from '../../../../redux/middleware/MedicalProtocolMiddleware';

// models
import { ErrorType } from '../../../../models/HttpError';
import { ProtocolPatient } from '../../../../models/Entities/Protocols/ProtocolPatient';
import { Protocol } from '../../../../models/Entities/Protocols/Protocol';
import { AppState } from '../../../../redux/reducers';
import { ProtocolConsumption } from '../../../../models/Entities/Protocols/ProtocolConsumption';

interface IProps {
  ProtocolId: number;
  onSelectedProtocolPatient: (patient: ProtocolPatient[]) => void;
  ProtocolPatientsSelectedNumber: string[] | undefined;
  MultiselectEnable: boolean;
  noteText?: string;
  TakeFromConsumptions?: boolean;
  showTitle?: boolean;
}

interface ConnectedProps {
  isLoading: boolean;
  isUpdating: boolean;
  isUpdatedSuccessfully: boolean;
  isLoadingSuccessfully: boolean;
  failOnUpdating: boolean;
  failOnLoading: boolean;
  error: ErrorType | undefined;
  Protocols: Protocol[];
  ProtocolPatients: ProtocolPatient[];
  ProtocolPatientsSelected: string[];
  ConsumptionProtocolPatients: string[];
}

interface DispatchProps {
  GetProtocolPatients: typeof MedicalProtocolsStore.actionCreators.GetProtocolPatients;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {
  const protocol = state.MedicalProtocols?.list?.find((item: Protocol) => item.id === ownProps.ProtocolId);

  const CurrentProtocolConsumptionsPatients: string[] | undefined = state.MedicalProtocols?.list ? state.MedicalProtocols.list.find((item: Protocol) => item.id === ownProps.ProtocolId)?.consumptions?.map((item: ProtocolConsumption) => item.patientNumberInProtocol).flatMap(
    (item: string) => item
  ) : [];

  
  return {
  isLoading: state.MedicalProtocols?.isLoadingAll,
  isUpdating: state.MedicalProtocols?.isUpdatingOne,
  isUpdatedSuccessfully: state.MedicalProtocols?.successUpdatingOne,
  isLoadingSuccessfully: state.MedicalProtocols?.successLoadingAll,
  failOnUpdating: state.MedicalProtocols?.failOnUpdatingOne,
  failOnLoading: state.MedicalProtocols?.failOnLoadingAll,
  isDeleting: state.MedicalProtocols?.isDeletingOne,
  isDeletedSuccessfully: state.MedicalProtocols?.successDeletingOne,
  failOnDeleting: state.MedicalProtocols?.failOnDeletingOne,
  error: state.MedicalProtocols?.error,
  Protocols: state.MedicalProtocols?.list,
  ProtocolPatients: state.MedicalProtocols?.list ? state.MedicalProtocols.list.find((item: Protocol) => item.id === ownProps.ProtocolId)?.patients : [],
  ProtocolPatientsSelected: ownProps.ProtocolPatientsSelectedNumber ? state.MedicalProtocols?.list ? state.MedicalProtocols.list.find((item: Protocol) => item.id === ownProps.ProtocolId)?.patients?.filter((patient: ProtocolPatient) => ownProps.ProtocolPatientsSelectedNumber?.includes(patient.numberInProtocol)) : [] : [],
  ProtocolConsumptions: state.MedicalProtocols?.list ? state.MedicalProtocols.list.find((item: Protocol) => item.id === ownProps.ProtocolId)?.consumptions : [],
  ConsumptionProtocolPatients: CurrentProtocolConsumptionsPatients ? new Set(CurrentProtocolConsumptionsPatients.map((item: string) => item )) : []

}};

export const mapDispatchToProps = ({
  ...MedicalProtocolsStore.actionCreators
});


export interface InternalMedicalInsuranceSelected {
  MedicalInsuranceId: number;
  MedicalInsurancePlanID?: number;
}



export const GetProtocolPatientOptions = (
  ProtocolId: number,
  protocolPatients: ProtocolPatient[]
): ITag[] => {

  const ProtocolPatients = protocolPatients?.filter(
    (item: ProtocolPatient) => item.protocolId === ProtocolId
  );
  
  var Patients = ProtocolPatients?.map((item: ProtocolPatient) => {
    return { key: item.numberInProtocol, name: item.numberInProtocol };
  });

  console.log('Pacientes', Patients);

  return Patients as ITag[];

};

// export const filterSuggestedMedicalServices = async (
//   filterText: string
// ): Promise<ITag[]> => {
//   return filterText && filterText.length > 4
//     ? MedicalService.GetMedicalServices(1, 100, filterText).then(
//         (services: AvailableMedicalService[]) => {
//           return services.map((item: AvailableMedicalService) => {
//             return { key: item.id, name: item.serviceNameReference };
//           });
//         }
//       )
//     : [];
// };

export const listContainsTagList = (tag: ITag, tagList?: ITag[]) => {
  if (!tagList || !tagList.length || tagList.length === 0) {
    return false;
  }
  return tagList.some((compareTag) => compareTag.key === tag.key);
};

export const GetProtocolPatientById = (
  numberInProtocol: string,
  protocolPatients: ProtocolPatient[]
): ProtocolPatient => {

  const protocolPatient: ProtocolPatient = protocolPatients?.find(
    (item: ProtocolPatient) => item.numberInProtocol === numberInProtocol
  ) as ProtocolPatient;

  return protocolPatient;
};

export async function GetSelectedProtocolPatient(
  protocolId: number,
  numberInProtocol: string[],
  protocolPatients: ProtocolPatient[]
): Promise<ITag[]> {
  const currentProtocolPatients: ITag[] = [];

  numberInProtocol.forEach(async (id: string) => {

    const patient: ProtocolPatient = GetProtocolPatientById(id, protocolPatients);

    currentProtocolPatients.push({
      key: patient.numberInProtocol,
      name: patient.numberInProtocol
    });
  });

  return [] as ITag[];;
}

export const getTextFromItem = (item: ITag) => item.name;

export const pickerSuggestionsProps: IBasePickerSuggestionsProps = {
  suggestionsHeaderText: 'pacientes sugeridos',
  noResultsFoundText: 'No se encontro paciente'
};
